// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__A1unQ","balance":"styles_balance__NxgfF"};